import { useQuery } from "@tanstack/react-query";

import { queryKeys } from "@/lib/query-keys";
import adminAPI from "@/services/api";

/**
 * GDS offices for the office select (SelectOffice.vue). `tenantId` (Upclaim only)
 * restreint la liste aux offices de ce client — sans lui, l'API renvoie ceux de l'agence
 * de l'appelant, et tous les offices pour un membre Upclaim.
 */
export function useGdsOffices(tenantId?: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.search.gdsOffices(tenantId),
    queryFn: () => adminAPI.listGdsOffices(tenantId ? { tenantId } : undefined),
    staleTime: 5 * 60_000,
    enabled,
  });
}
